// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"a5339032","615":"d34b5573","881":"d34b5573","919":"d34b5573","964":"d34b5573"}[chunkId] + ".chunk.css";
};